import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "avatar-circle",
  "use": "avatar-circle-usage",
  "viewBox": "-1 -1 37 37",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"-1 -1 37 37\" id=\"avatar-circle\">\n    <g fill=\"none\" fill-rule=\"nonzero\">\n        <circle cx=\"17.5\" cy=\"17.5\" r=\"17.5\" fill=\"#FFF\" stroke=\"#D8D8D8\" />\n        <path fill=\"#BCBEC0\" d=\"M17.5 18c4.142 0 7.5 1.567 7.5 3.5V24H10v-2.5c0-1.933 3.358-3.5 7.5-3.5zm6.5 3.5c0-1.38-2.91-2.5-6.5-2.5S11 20.12 11 21.5V23h13v-1.5zM17.5 9a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7zm0 1a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5z\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol